/**
 * !!! WARNING !!!
 * This balloon implementation is deprecated,
 * please use Podio.Views.SimpleBalloon instead.
 */

define('lib/Podio.UI.SettingsBalloon',['require','underscore','jquery','lib/Podio.Event.UI','signals'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var eventUI = require('lib/Podio.Event.UI');
  var signalsLib = require('signals');

  var signals = {
    onInitialized : new signalsLib.Signal(),
    onShow : new signalsLib.Signal(),
    onHide : new signalsLib.Signal(),
    onApply : new signalsLib.Signal(),
    onCancel : new signalsLib.Signal(),
    onRemove : new signalsLib.Signal()
  };

  var helpers = {
    showBallon: function(elmAnchor, elmBalloon) {
      var topPosition, bottomPosition;
      var withinModal = elmAnchor.parents('.modal').length > 0;
      if(withinModal) {
        elmBalloon.addClass('within-modal');
      }

      var offset = elmAnchor.offset();

      if(elmBalloon.hasClass('fixed')) {
        offset.top = offset.top - $(document).scrollTop();
      }

      var availableSpace = $(window).width()-(offset.left+(elmAnchor.outerWidth()/2)-24);
      if (elmBalloon.hasClass('left')) {
        elmBalloon.css('left', offset.left - elmBalloon.width() - 5);
      } else if (availableSpace > elmBalloon.width()) {
        elmBalloon.removeClass('settings-balloon-right');
        elmBalloon.css('left', offset.left+(elmAnchor.outerWidth()/2)-24);
      }
      else {
        elmBalloon.addClass('settings-balloon-right');
        elmBalloon.css('left', offset.left+(elmAnchor.outerWidth()/2)+24-elmBalloon.width());
      }

      if (elmBalloon.hasClass('left')) {
        bottomPosition = window.innerHeight - (offset.top + (elmAnchor.outerHeight() / 2));
        elmBalloon.css({ bottom: bottomPosition, top: 'auto' });
      } else {
        topPosition = offset.top+elmAnchor.outerHeight()-5;
        elmBalloon.css('top', topPosition);
      }

      helpers.syncSetClass(elmAnchor, elmBalloon);

      elmBalloon.fadeIn('fast', function() {
        elmBalloon.find('.buttons .apply').bind('click', handlers.onApplyClicked.curry(elmAnchor, elmBalloon));
        elmBalloon.find('.buttons .cancel').bind('click', handlers.onCancelClicked.curry(elmAnchor, elmBalloon));
        elmBalloon.find('.buttons .remove').bind('click', handlers.onRemoveClicked.curry(elmAnchor, elmBalloon));
        elmBalloon.bind('outsideclick', handlers.onOutsideClick.curry(elmAnchor, elmBalloon));
        signals.onShow.dispatch(elmAnchor, elmBalloon);
      });

      elmAnchor.addClass('open');
    },

    hideBallon: function(elmAnchor, elmBalloon) {
      elmBalloon.find('.buttons .apply').unbind('click');
      elmBalloon.find('.buttons .cancel').unbind('click');
      elmBalloon.find('.buttons .remove').unbind('click');
      elmBalloon.unbind('outsideclick');

      elmBalloon.fadeOut('fast', function() {
        signals.onHide.dispatch(elmAnchor, elmBalloon);
      });
      elmAnchor.removeClass('open');
    },

    getFormFields: function(elmBalloon) {
      return elmBalloon.find('input:not([type=submit],[type=button]), select, textarea');
    },

    copyFormFields: function(elmAnchor, elmBalloon) {
      var formFields = helpers.getFormFields(elmBalloon);
      var fieldNames = _.map(formFields, function(node) { return node.name; });
      var form = elmAnchor.parents('form:first');
      _.each(formFields, function(field) {
        var name = field.name;
        var value = helpers.valueForFormField($(field));
        var hiddenField = $('<input/>').attr('type', 'hidden').attr('name', name).attr('value', value);
        form.append(hiddenField);
      });
    },

    restoreFormValues: function(elmAnchor, elmBalloon) {
      helpers.withEachFieldPair(elmAnchor, elmBalloon, function(elmHiddenField, elmBalloonField) {
        if(elmBalloonField.is('[type="checkbox"]')) {
          elmBalloonField.prop('checked', elmHiddenField.val() == '1' ? true : false); // Checkbox
        } else {
          elmBalloonField.val(elmHiddenField.val()); // Other type of field
        }
      });
    },

    applyFormValues: function(elmAnchor, elmBalloon) {
      helpers.withEachFieldPair(elmAnchor, elmBalloon, function(elmHiddenField, elmBalloonField) {
        elmHiddenField.val(helpers.valueForFormField(elmBalloonField));
      });
    },

    removeFormValues: function(elmAnchor, elmBalloon) {
      helpers.withEachFieldPair(elmAnchor, elmBalloon, function(elmHiddenField, elmBalloonField) {
        if(elmBalloonField.is('[type="checkbox"]')) {
          elmHiddenField.val('0');
          elmBalloonField.prop('checked', false);
        } else {
          elmHiddenField.val('');
          elmBalloonField.val('');
        }
      });
    },

    withEachFieldPair: function(elmAnchor, elmBalloon, callback) {
      var formFields = helpers.getFormFields(elmBalloon);
      var form = elmAnchor.parents('form:first');
      _.each(formFields, function(field) {
        var elmHiddenField = form.find("[name='" + field.name + "']");
        var elmBalloonField = $(field);
        if(elmHiddenField.length && elmBalloonField.length) {
          callback(elmHiddenField, elmBalloonField);
        }
      });
    },

    valueForFormField: function(elmFormField) {
      if(elmFormField.is('[type="checkbox"]')) {
        return elmFormField.is(':checked') ? '1' : '0';
      } else {
        return elmFormField.val();
      }
    },

    syncSetClass: function(elmAnchor, elmBalloon) {
      if(elmAnchor.hasClass('set')) {
        elmBalloon.addClass('set');
      } else {
        elmBalloon.removeClass('set');
      }
    },

    hideAll: function() {
      $('.settings-balloon').hide();
    },

    clear: function(elmAnchor, elmBalloon) {
      helpers.removeFormValues(elmAnchor, elmBalloon);
      helpers.syncSetClass(elmAnchor, elmBalloon);
    },

    destroy: function(elmAnchor) {
      var balloonQuery = elmAnchor.data('settings-balloon');
      var elmBalloon = $(balloonQuery);
      elmBalloon.each(function(){
        if($(this).parent().is('body')) {
          $(this).remove();
        }
      });
    }
  };

  var handlers = {
    onAnchorClicked: function(elmAnchor, e) {
      var balloonQuery = elmAnchor.data('settings-balloon');
      var elmBalloon = $(balloonQuery);
      if(!elmBalloon.parent().is('body')) {
        elmBalloon.appendTo($('body'));
        helpers.copyFormFields(elmAnchor, elmBalloon); // Insert hidden form fields into the source form
        signals.onInitialized.dispatch(elmAnchor, elmBalloon);
      }

      if(elmAnchor.hasClass('open')) {
        helpers.hideBallon(elmAnchor, elmBalloon);
        helpers.restoreFormValues(elmAnchor, elmBalloon);
      } else {
        helpers.showBallon(elmAnchor, elmBalloon);
      }
    },

    onApplyClicked: function(elmAnchor, elmBalloon, elmButton, e) {
      helpers.hideBallon(elmAnchor, elmBalloon);
      helpers.applyFormValues(elmAnchor, elmBalloon);
      signals.onApply.dispatch(elmAnchor, elmBalloon);
      helpers.syncSetClass(elmAnchor, elmBalloon);
      return false;
    },

    onCancelClicked: function(elmAnchor, elmBalloon, elmButton, e) {
      helpers.restoreFormValues(elmAnchor, elmBalloon);
      helpers.hideBallon(elmAnchor, elmBalloon);
      signals.onCancel.dispatch(elmAnchor, elmBalloon);
      helpers.syncSetClass(elmAnchor, elmBalloon);
      return false;
    },

    onRemoveClicked: function(elmAnchor, elmBalloon, elmButton, e) {
      helpers.removeFormValues(elmAnchor, elmBalloon);
      helpers.hideBallon(elmAnchor, elmBalloon);
      signals.onRemove.dispatch(elmAnchor, elmBalloon);
      helpers.syncSetClass(elmAnchor, elmBalloon);
      return false;
    },

    onOutsideClick: function(elmAnchor, elmBalloon, e) {
      if (($(e.target).is('.settings-balloon')) || ($(e.target).parents('.settings-balloon').length) || ($(e.target).parents('.ui-datepicker').length) || ($(e.target).parents('.ui-datepicker-header').length)) {
        return;
      }

      helpers.hideBallon(elmAnchor, elmBalloon);

      signals.onHide.addOnce(function() {
        helpers.restoreFormValues(elmAnchor, elmBalloon);
        signals.onCancel.dispatch(elmAnchor, elmBalloon);
        helpers.syncSetClass(elmAnchor, elmBalloon);
      });
    }

  };

  eventUI.bind('click', '*[data-settings-balloon]:not(.disabled)', handlers.onAnchorClicked);

  return {
    signals: signals,
    hideAll: helpers.hideAll,
    clear: helpers.clear,
    destroy: helpers.destroy
  };

});


